import {
  CreateStepNoticeModel,
  List,
  StepNoticeModel,
  StepNoticeWithContentModel,
} from '@partful/instructions-domain-models';
import { useTenant } from '@providers/Tenant';
import { InfiniteData, QueryClient, useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { instructionQueryKeys } from '../../shared/api/queryKeys';
import { StepsService } from '../api/stepsService';

interface MutationVariables {
  instructionId: string;
  versionId: string;
  segmentId: string;
  stepId: string;
  args: CreateStepNoticeModel;
}

export const useCreateStepNotice = () => {
  const queryClient = useQueryClient();
  const { accountId } = useTenant();
  const service = useMemo(() => new StepsService(), []);

  return useMutation<StepNoticeModel & Partial<StepNoticeWithContentModel>, unknown, MutationVariables>({
    mutationFn: ({ instructionId, versionId, segmentId, stepId, args }) =>
      service.createNotice(accountId, instructionId, versionId, segmentId, stepId, args),
    onSuccess: (data, { stepId }) => {
      addStepNoticeToCache(queryClient, data, stepId);
    },
  });
};

function addStepNoticeToCache(
  queryClient: QueryClient,
  notice: StepNoticeModel & Partial<StepNoticeWithContentModel>,
  stepId: string
) {
  queryClient.setQueryData<InfiniteData<List<StepNoticeModel & Partial<StepNoticeWithContentModel>>>>(
    [instructionQueryKeys.listStepNotices, stepId],
    (oldData) => {
      if (oldData != null) {
        return {
          ...oldData,
          pages: oldData.pages.map((page, index) => {
            if (index === oldData.pages.length - 1) {
              return { ...page, items: [...page.items, notice] };
            }
            return page;
          }),
        };
      }
    }
  );
}
